// M&D — Le site est servi statiquement depuis /public/
// React reste présent (build CRA) mais ne rend rien : la fidélité au site original est garantie.
function App() {
  return null;
}

export default App;
